(function ($) {
    // function facebookLogin() {
    //     FB.api('/me?fields=email,name,picture', function (response) {
    //         var email = response.email;
    //         var name = response.name;
    //         var picture = 'https://graph.facebook.com/' + response.id + '/picture';
    //         var id = response.id;
    //         var redirect = $('.login-input-info[name="redirect"]').val();
    //
    //         var data = {
    //             'action': 'login_social',
    //             'email': email,
    //             'name': name,
    //             'picture': picture,
    //             'id': id,
    //             'redirect': redirect
    //         };
    //         $.get(postmpwp.ajax_url, data, function (response) {
    //             if (response.success) {
    //                 window.location.href = response.data.redirect;
    //             } else {
    //                 $('.login-popup .loading').removeClass('active');
    //                 $('.login-popup .error-message').addClass('visible');
    //                 $('.login-popup .error-message').text(response.data.error);
    //             }
    //         });
    //     });
    // }
    //
    // function emailLogin() {
    //     var email = $('.login-input-info[name="email"]').val();
    //     var name = $('.login-input-info[name="name"]').val();
    //     var redirect = $('.login-input-info[name="redirect"]').val();
    //
    //     var data = {
    //         'action': 'login_social',
    //         'email': email,
    //         'name': name,
    //         'redirect': redirect,
    //     };
    //     $.get(postmpwp.ajax_url, data, function (response) {
    //         if (response.success) {
    //             window.location.href = response.data.redirect;
    //         } else {
    //             $('.login-popup .loading').removeClass('active');
    //             $('.login-popup .error-message').addClass('visible');
    //             $('.login-popup .error-message').text(response.data.error);
    //         }
    //     });
    // }

    function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }

    function sendMessage(value) {
        $('.chat-input-box').addClass('loading').removeClass('invalid');
        var data = {
            'action': 'add_comment',
            'content': value.val(),
            'post_id': value.attr('data-postID'),
            'user_name': value.attr('data-username'),
            'user_id': value.attr('data-userID'),
            'parent_id': value.attr('data-parentID'),
        };
        $.post(postmpwp.ajax_url, data, function (response) {
            console.log(response);
            $('.comment-input').val('');
            if (response.success) {
                $('.message-response').removeClass('active');
                $('.comment-input').attr('data-parentID', 0);
                $('.chat-input-box').removeClass('invalid').removeClass('loading');
                $('.simplebar-content').append(response.data.comment);
                $('.simplebar-content-wrapper').scrollTop($('.simplebar-content').height());
            } else {
                $('.chat-input-box').addClass('invalid').removeClass('loading');
                $('.comment-input').attr('placeholder', response.split('.')[0]);
            }
        });
    }

    if ($('.page-template-template-live').length) {
        setTimeout(function () {
            $('.simplebar-content-wrapper').scrollTop($('.simplebar-content').height());
        }, 2000);
        $(document).on('click', '.reply-button', function () {
            var id = $(this).closest('.chat-message').attr('data-id');
            $('.comment-input').attr('data-parentID', id);
            $('.message-response').addClass('active');
            $('.message-response').find('.name').text($(this).closest('.chat-message').find('.take-name').text());
            $('.message-response').find('.content').text($(this).closest('.chat-message').find('.text').text());
        });
        $('.close-response').on('click', function () {
            $('.message-response').removeClass('active');
            $('.comment-input').attr('data-parentID', 0);
        })
        $('.parent-comment').each(function () {
            $(this).addClass('active');
            var height = $(this).outerHeight(true) - 15;
            $(this).css('height', height);
            $(this).removeClass('active');
            if (height <= 65) {
                $(this).addClass('non-expandable');
            }
        })
        $(document).on('click', '.more-button', function () {
            if (!$(this).closest('.parent-comment').hasClass('active')) {
                $(this).closest('.parent-comment').addClass('active');
                $(this).text($(this).attr('data-text-less'));
            } else {
                $(this).closest('.parent-comment').removeClass('active');
                $(this).text($(this).attr('data-text-more'));
            }
        });
        $(document).on('keyup', '.login-input-info[name="name"]', function (e) {
            if ($(this).val() !== '') {
                $(this).removeClass('error');
                $('.comment-input').attr('data-username', $(this).val());
                setCookie('username', $(this).val(), 1);
            } else {
                $(this).addClass('error');
                $('.comment-input').attr('data-username', 0);
            }

        });
        $('.facebook-login').on('click', function () {
            $('.login-popup .loading').addClass('active');
            FB.login(function (response) {
                if (response.status === 'not_authorized') {
                    $('.login-popup .loading').removeClass('active');
                }

                if (response.status === 'unknown') {
                    $('.login-popup .loading').removeClass('active');
                }

                if (response.status === 'connected') {
                    if (response.authResponse.grantedScopes === 'email,public_profile') {
                        facebookLogin();
                    } else {
                        $('.login-popup .loading').removeClass('active');
                    }
                }

            }, {scope: 'email,public_profile', auth_type: 'rerequest', return_scopes: true});
        });
        $('.email-login').on('click', function () {
            $('.login-popup .error-message').removeClass('visible');
            $('.login-input-info[name="email"]').removeClass('error');
            $('.login-input-info[name="name"]').removeClass('error');

            var email = $('.login-input-info[name="email"]').val();
            var name = $('.login-input-info[name="name"]').val();
            var valid = true;

            if (!/(.+)@(.+){2,}\.(.+){2,}/.test(email)) {
                $('.login-input-info[name="email"]').addClass('error');
                valid = false;
            }
            if (name.length < 4) {
                $('.login-input-info[name="name"]').addClass('error');
                valid = false;
            }
            if (valid) {
                $('.login-popup .loading').addClass('active');
                emailLogin();
            }
        });

        $('.comment-input').on('keypress', function (e) {
            $(this).attr('placeholder', $(this).attr('data-placeholder'));
            if (e.keyCode === 13) {
                if ($('.comment-input').attr('data-username') === '0') {
                    $('.login-input-info').addClass('error');
                } else {
                    if ($('.comment-input').val() != '') {
                        $('.login-popup').removeClass('active');
                        sendMessage($(this));
                    } else {
                        $('.chat-input-box').addClass('invalid');
                    }
                }
            }
        });

        $('.send-button').on('click', function () {
            if ($('.comment-input').attr('data-username') === '0') {
                $('.login-input-info').addClass('error');
            } else {
                if ($('.comment-input').val() != '') {
                    $('.login-popup').removeClass('active');
                    sendMessage($(this).siblings('.comment-input'));
                } else {
                    $('.chat-input-box').addClass('invalid');
                }
            }
        });

        const swiper = new Swiper('.swiper', {
            speed: 400,
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: {
                nextEl: '.custom-button-next',
                prevEl: '.custom-button-prev'
            },
            breakpoints: {
                // when window width is >= 480px
                500: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 640px
                990: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            }
        });
    }

})(jQuery);